export enum Popover {
    gamePopUpShown = 'gamepopupShown',
    Id_1043 = '1043',
    Id_1008 = '1008',
    Id_1006 = '1006',
    syndicatePopupShown = 'syndicatepopupShown',
    syndicate = 'syndicate',
    game = 'game',
    popupShown = "popupshow",
    isTrue = 'true',
    /** localStorage prefix for games onboarding popups (HATDEV-90338). */
    gameOnboardingPopupPrefix = 'game_onboarding_popup_',
}
